import React, { useState, useMemo } from 'react';
import { Input, Button } from 'reactstrap';

const CannedResponsePicker = ({ 
  templates = [], 
  onSelect, 
  onClose,
  isOpen = false 
}) => {
  const [search, setSearch] = useState('');

  const filteredTemplates = useMemo(() => {
    if (!search.trim()) return templates;
    const lower = search.trim().toLowerCase();
    return templates.filter(template => {
      const haystack = [template.title, template.shortcut, template.content].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(lower);
    });
  }, [templates, search]);

  const getTemplatePreview = (value, length = 80) => {
    if (!value) return '';
    if (value.length <= length) return value;
    return `${value.slice(0, length)}…`;
  };

  if (!isOpen) return null;

  return (
    <div
      className="canned-response-picker"
      style={{
        position: 'absolute',
        bottom: '100%',
        left: 0,
        marginBottom: '8px',
        width: '320px',
        maxHeight: '360px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
        padding: '12px',
        zIndex: 1000,
        border: '1px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
        <Input
          type="search"
          placeholder="Search templates..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ fontSize: '13px' }}
          autoFocus
        />
        {onClose && (
          <Button
            color="link"
            size="sm"
            onClick={onClose}
            style={{ padding: '4px 8px', fontSize: '12px' }}
          >
            Close
          </Button>
        )}
      </div>
      
      <div style={{ maxHeight: '260px', overflowY: 'auto', flex: 1 }}>
        {filteredTemplates.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>
            {search ? 'No templates match your search.' : 'No templates available yet.'}
          </div>
        ) : (
          filteredTemplates.map(template => (
            <button
              key={template.id}
              type="button"
              onClick={() => {
                if (onSelect) onSelect(template);
                if (onClose) onClose();
              }}
              style={{
                width: '100%',
                textAlign: 'left',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                padding: '10px',
                marginBottom: '8px',
                background: '#fff',
                cursor: 'pointer',
                transition: 'all 0.15s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#f9fafb';
                e.target.style.borderColor = '#2563eb';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#fff';
                e.target.style.borderColor = '#e0e0e0';
              }}
            >
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#1f2937', marginBottom: '4px' }}>
                {template.title || 'Untitled template'}
              </div>
              {template.shortcut && (
                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>
                  Shortcut: <code style={{ background: '#f3f4f6', padding: '2px 4px', borderRadius: '3px' }}>{template.shortcut}</code>
                </div>
              )}
              <div style={{ fontSize: '12px', color: '#6b7280' }}>
                {getTemplatePreview(template.content)}
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default CannedResponsePicker;

